// extracted by mini-css-extract-plugin
export var actionButton = "_ip-0";
export var fileInput = "_ip-2";
export var paperclip = "_ip-1";